<template>
  <div class="full-area">
    <header class="question-header" v-if="!(data.fields.questionImage && data.fields.questionImage.fields.file.url)">
      <h2>{{data.fields.title}}</h2>
    </header>

    <header class="question-header image-question contain-image"
      v-if="data.fields.questionImage && data.fields.questionImage.fields.file.url"
    >
      <div
        class="img"
        :style="{'backgroundImage': `url(${data.fields.questionImage.fields.file.url})`}"
      ></div>
    </header>
    <content class="content delay-entry" :class="{'is-vertical': this.data.fields.isVertical}">
      <div
        class="slider-value"
        :class="{'hide': sliderValue === ((this.form.to - this.form.from) / 2 + 0.00001), 'text-scale': data.fields.useTextScale}"
      >
        {{numbersToTextScale(sliderValue)}}
      </div>
      <div class="slider-wrapper">
        <el-slider
          :min="form.from"
          :max="form.to"
          :show-tooltip="false"
          :vertical="data.fields.isVertical"
          height="40vh"
          v-model="sliderValue"
        ></el-slider>
      </div>
    </content>
    <footer>
      <SkipQuestionButton
        :location="'locate-bottom'"
        v-on:skip="selectThis('NS/NR')"
      ></SkipQuestionButton>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Slider',

  props: [ 'data' ],

  components: {
    SkipQuestionButton: () => import('Components/base/SkipQuestionButton')
  },

  data () {
    return {
      sliderValue: null,
      form: {
        question: this.data.fields.title,
        id: this.data.sys.id,
        from: isNaN(this.data.fields.from) ? 1 : this.data.fields.from,
        to: this.data.fields.to || this.data.fields.textScale.length,
        selected: null,
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      },
      timer: null
    }
  },

  mounted () {
    this.sliderValue = (this.form.to - this.form.from) / 2 + 0.00001
  },

  methods: {
    selectThis (item) {
      this.form.selected = item
      this.form.timestamps.valid = new Date()
      this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
      setTimeout(() => {
        this.next()
      }, 200)
    },
    next () {
      this.form.timestamps.finish = new Date()
      this.$emit('next', this.form)
    },
    validInput (value) {
      // Add simple validation: if it exists, it is valid.
      if (value >= this.form.from && value <= this.form.to) {
        return true
      } else {
        return false
      }
    },
    numbersToTextScale (value) {
      if (!this.data.fields.useTextScale) {
        return value
      }
      if (this.data.fields.from === 1 && this.data.fields.to === 4) {
        switch (value) {
          case 1:
            return 'Para nada'
          case 2:
            return 'No mucho'
          case 3:
            return 'Algo'
          case 4:
            return 'Completamente'
          default:
            return 'Mueve la bolita'
        }
      }
      if (this.data.fields.from === 1 && this.data.fields.to === 5) {
        switch (value) {
          case 1:
            return 'Totalmente en desacuerdo'
          case 2:
            return 'Parcialmente en desacuerdo'
          case 3:
            return 'Neutral'
          case 4:
            return 'Parcialmente de acuerdo'
          case 5:
            return 'Totalmente de acuerdo'
          default:
            return 'Mueve la bolita'
        }
      }
    }
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'form.selected': function (newVal, oldVal) {
      if (this.validInput(newVal) && Number.isInteger(newVal)) {
        setTimeout(() => {
          this.next()
        }, 200)
      }
    },
    'sliderValue': function (newVal, oldVal) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.form.selected = newVal
      }, 1500)
    }
  }
}
</script>

<style lang="scss">
  .content {
    &.is-vertical {
      .el-slider__runway {
        margin: auto;
      }
    }
  }
</style>

<style scoped lang="scss">
  .question-header.align-bottom {
    max-height: 20vh;
  }
  .content {
    margin-bottom: 60px;
    flex-direction: column;

    &.is-vertical {
      flex-direction: row-reverse;

      .slider-wrapper {
        width: 100%;
        margin: auto;
      }
      .slider-value {
        position: absolute;
        width: 30%;
        right: 0;
        text-align: left;
      }

      .el-slider__runway {
        margin: auto;
      }
    }
  }

  .slider-wrapper {
    width: 80%;
    margin: 0 auto;

    @include breakpoint($tablet) {
      width: 70%;
    }
  }

  .slider-value {
    margin: 0 auto;
    display: block;
    font-weight: bold;
    font-size: 2em;
    line-height: 40px;
    color: $color-emphasis-blue;
    transition: all 0.2s ease-in-out;

    @include breakpoint($tablet) {
      line-height: 80px;
    }

    &.text-scale {
      font-weight: bold;
      font-size: 1.3em;
      line-height: 40px;
      @include breakpoint($tablet) {
        line-height: 80px;
      }
    }
  }
  .hide {
    opacity: 0;
  }

</style>
